
  class SocialShare extends HTMLElement {
    constructor() {
        super();
        this.init();
    }
    init() {
        this.querySelectorAll('.btn-sharing').forEach(share => {
            share.addEventListener("click", event => {
              event.preventDefault();
              const target = event.currentTarget;
              const social = target.getAttribute('data-social');
              const windowName = target.getAttribute('data-window-name') || '';
              const windowFeatures = target.getAttribute('data-window-features') || '';
              window.open(social, windowName, windowFeatures);
            }, false);
        });
    }
  }
  customElements.define("social-share", SocialShare);
  